// extracted by mini-css-extract-plugin
module.exports = {"footer":"e92e","list":"_8a67","item":"_4cf5","bottomDiv":"_935b","version":"_9e33","linkDiv":"ba33","logoImage":"_186b"};